import React from 'react';

import './MobileDataControl.scss';

/**
 * @param {object} props
 * @param {boolean} props.disabledNext
 * @param {boolean} props.disabledPrev
 * @param {() => void} props.onNext
 * @param {() => void} props.onPrev
 * @param {JSX.Element} props.children
 */
export const MobileDataControl = (props) => {
  const { onNext, onPrev, disabledNext, disabledPrev } = props;

  return (
    <div className='feature-genset-MD MobileDataControl'>
      <div className='content'>
        <button
          className='content-button'
          disabled={disabledPrev}
          onClick={onPrev}
        >
          <svg
            className='bvt-date-picker__header__svg'
            height='11.374'
            viewBox='0 0 7.132 11.374'
            width='7.132'
          >
            <g transform='translate(11.061 5.687) rotate(135)'>
              <rect
                fill='currentColor'
                height='2.486'
                rx='1.243'
                transform='translate(0 5.557)'
                width='7.6'
              />
              <rect
                fill='currentColor'
                height='2.486'
                rx='1.243'
                transform='translate(8.043 0) rotate(90)'
                width='7.6'
              />
            </g>
          </svg>
        </button>
        {props?.children}
        <button
          className='content-button'
          disabled={disabledNext}
          onClick={onNext}
        >
          <svg height='11.374' viewBox='0 0 7.132 11.374' width='7.132'>
            <g transform='translate(-3.929 5.687) rotate(-45)'>
              <rect
                fill='currentColor'
                height='2.486'
                rx='1.243'
                transform='translate(0 5.557)'
                width='7.6'
              />
              <rect
                fill='currentColor'
                height='2.486'
                rx='1.243'
                transform='translate(8.043 0) rotate(90)'
                width='7.6'
              />
            </g>
          </svg>
        </button>
      </div>
    </div>
  );
};
